import request from '@/utils/request'

export function getCms(code) {
  return request({
    url: '/biz/giftcard/cms/get',
    method: 'get',
    params: { code }
  })
}

export function listCms() {
  return request({
    url: '/biz/giftcard/cms/list',
    method: 'get'
  })
}

export function saveCms(data) {
  return request({
    url: '/biz/giftcard/cms/save',
    method: 'post',
    data
  })
}
